import { IRecipient } from "../store/slices/c2cSlice"

const PHONE_REGEX = /^\+7\d{10}$/

export const isPhoneNumber = (phone: string) => {
  const phoneNoSpaces = phone.replace(/\s+/g, "")
  return PHONE_REGEX.test(phoneNoSpaces)
}

const extractDigitsFromPhone = (phone: string) => {
  const regex = /\d+/g
  const digitsArray = phone.match(regex)
  const digitsString = digitsArray ? digitsArray.join("") : ""

  return digitsString
}

const sanitizeName = (name: string) => name.toLowerCase().replace(/\s+/g, "")

export const filterContactsByPhoneAndName = (
  contacts: IRecipient[],
  query: string,
) =>
  contacts.filter((contact) => {
    const { name, phone } = contact
    const sanitizedName = sanitizeName(name!)
    const sanitizedPhone = extractDigitsFromPhone(phone)

    const isPhone = query.startsWith("+7")

    if (isPhone) {
      return sanitizedPhone.includes(extractDigitsFromPhone(query))
    }
    
    return sanitizedName.includes(sanitizeName(query))
  })
